<script>
// Components
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import UserProfile from "@/router/views/users/user-profile"

// Services
import MediaDataService from "@/services/MediaDataService";
import UsersDataService from "@/services/UsersDataService";
import AdminService from "@/services/AdminService";

// import
import Storage from "@/helpers/storage";
import {authComputed} from "@/state/helpers";
import UserUtils from '@/helpers/users'
import DateUtils from '@/helpers/date';
import AdminUtils from '@/helpers/admin';
import HelperUtils from '@/helpers/helper';
import { Role, getRole } from '@/helpers/role'

// External Components
import CoolLightBox from 'vue-cool-lightbox';
import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css';
import DatePicker  from "vue2-datepicker";
import 'vue2-datepicker/index.css';
import {VueTabs, VTab} from 'vue-nav-tabs'
import 'vue-nav-tabs/themes/vue-tabs.css';
import isEmpty from "is-empty";
import countriesISO from "i18n-iso-countries";

export default {
  page: {
    localePicker: () => import(`vue2-datepicker/locale/${this.$i18n.locale}`),
    title: "Moderation Checks",
    meta: [
      {
        name: "description",
        content: appConfig.description
      },
    ],
  },

  components: {
    Layout,
    PageHeader,
    DatePicker,
    VueTabs,
    VTab,
    UserProfile,
    CoolLightBox,
  },

  methods: {
    isEmpty,
    ...UserUtils,
    ...DateUtils,
    ...HelperUtils,

    loadOperators() {
      AdminService
          .getOperators()
          .then(response => {
            response.data.operators.forEach(op => {
              this.filtersMedia.operators.options.push({
                value: op.documentId,
                text: op.operator
              });

              this.filtersMediaDeleted.operators.options.push({
                value: op.documentId,
                text: op.operator
              });

              this.filtersMediaScored.operators.options.push({
                value: op.documentId,
                text: op.operator
              });

              this.filtersUpdates.operators.options.push({
                value: op.documentId,
                text: op.operator
              });

              this.filtersProfiles.operators.options.push({
                value: op.documentId,
                text: op.operator
              });
            });
          })
          .catch(error => {
            window.console.log(error);
          });
    },

    handleMediaDisplayChange() {
      this.pageMedia = 1;
      this.processFiltersMedia();
    },

    handleMediaScoredDisplayChange() {
      this.pageMediaDeleted = 1;
      this.processFiltersMediaDeleted();
    },

    handleMediaDeletedDisplayChange() {
      this.pageMediaDeleted = 1;
      this.processFiltersMediaDeleted();
    },

    handleUpdatesDisplayChange() {
      this.pageUpdates = 1;
      this.processFiltersUpdates();
    },

    handleProfileDisplayChange() {
      this.pageProfiles = 1;
      this.processFiltersProfiles();
    },

    handleMediaPageChange(value) {
      this.pageMedia = value;
      this.processFiltersMedia();
    },

    handleMediaScoredPageChange(value) {
      this.pageMediaScored = value;
      this.processFiltersMediaScored();
    },

    handleMediaDeletedPageChange(value) {
      this.pageMediaDeleted = value;
      this.processFiltersMediaDeleted();
    },

    handleUpdatesPageChange(value) {
      this.pageUpdates = value;
      this.processFiltersUpdates();
    },

    handleProfilesPageChange(value) {
      this.pageProfiles = value;
      this.processFiltersProfiles();
    },

    handleMediaDateChange() {
      let now = new this.$moment();
      switch(this.filtersMedia.dates.selected) {
        case "always":
          this.filtersMedia.fromDate = new this.$moment('2021-01-01').format('YYYY-MM-DD');
          this.filtersMedia.toDate = now.format('YYYY-MM-DD');
          break;
        case "today":
          this.filtersMedia.fromDate = now.format('YYYY-MM-DD');
          this.filtersMedia.toDate = now.format('YYYY-MM-DD');
          break;
        case "yesterday":
          this.filtersMedia.fromDate = now.subtract(1, 'day').format('YYYY-MM-DD');
          this.filtersMedia.toDate = this.filtersMedia.fromDate;
          break;
        case "week":
          this.filtersMedia.toDate = now.format('YYYY-MM-DD');
          this.filtersMedia.fromDate = now.subtract(1, 'week').startOf('day').format('YYYY-MM-DD');
          break;
        case "curMonth":
          this.filtersMedia.toDate = now.format('YYYY-MM-DD');
          this.filtersMedia.fromDate = now.startOf('month').format('YYYY-MM-DD');
          break;
        case "last30Day":
          this.filtersMedia.toDate = now.format('YYYY-MM-DD');
          this.filtersMedia.fromDate = now.subtract(30, 'day').startOf('day').format('YYYY-MM-DD');
          break;
        case "lastMonth":
          this.filtersMedia.fromDate = now.subtract(1, 'month').startOf('month').format('YYYY-MM-DD');
          this.filtersMedia.toDate = now.endOf('month').format('YYYY-MM-DD');
          break;
        case "last3Month":
          this.filtersMedia.toDate = now.format('YYYY-MM-DD');
          this.filtersMedia.fromDate = now.subtract(3, 'month').startOf('day').format('YYYY-MM-DD');
          break;
        case "curYear":
          this.filtersMedia.toDate = now.format('YYYY-MM-DD');
          this.filtersMedia.fromDate = now.startOf('year').format('YYYY-MM-DD');
          break;
        case "custom":
          this.filtersMedia.fromDate = null;
          this.filtersMedia.toDate = null;
          break;
      }
    },

    handleMediaScoredDateChange() {
      let now = new this.$moment();
      switch(this.filtersMediaScored.dates.selected) {
        case "always":
          this.filtersMediaScored.fromDate = new this.$moment('2021-01-01').format('YYYY-MM-DD');
          this.filtersMediaScored.toDate = now.format('YYYY-MM-DD');
          break;
        case "today":
          this.filtersMediaScored.fromDate = now.format('YYYY-MM-DD');
          this.filtersMediaScored.toDate = now.format('YYYY-MM-DD');
          break;
        case "yesterday":
          this.filtersMediaScored.fromDate = now.subtract(1, 'day').format('YYYY-MM-DD');
          this.filtersMediaScored.toDate = this.filtersMediaScored.fromDate;
          break;
        case "week":
          this.filtersMediaScored.toDate = now.format('YYYY-MM-DD');
          this.filtersMediaScored.fromDate = now.subtract(1, 'week').startOf('day').format('YYYY-MM-DD');
          break;
        case "curMonth":
          this.filtersMediaScored.toDate = now.format('YYYY-MM-DD');
          this.filtersMediaScored.fromDate = now.startOf('month').format('YYYY-MM-DD');
          break;
        case "last30Day":
          this.filtersMediaScored.toDate = now.format('YYYY-MM-DD');
          this.filtersMediaScored.fromDate = now.subtract(30, 'day').startOf('day').format('YYYY-MM-DD');
          break;
        case "lastMonth":
          this.filtersMediaScored.fromDate = now.subtract(1, 'month').startOf('month').format('YYYY-MM-DD');
          this.filtersMediaScored.toDate = now.endOf('month').format('YYYY-MM-DD');
          break;
        case "last3Month":
          this.filtersMediaScored.toDate = now.format('YYYY-MM-DD');
          this.filtersMediaScored.fromDate = now.subtract(2, 'month').startOf('month').format('YYYY-MM-DD');
          break;
        case "curYear":
          this.filtersMediaScored.toDate = now.format('YYYY-MM-DD');
          this.filtersMediaScored.fromDate = now.startOf('year').format('YYYY-MM-DD');
          break;
        case "custom":
          this.filtersMediaScored.fromDate = null;
          this.filtersMediaScored.toDate = null;
          break;
      }
    },

    handleMediaDeletedDateChange() {
      let now = new this.$moment();
      switch(this.filtersMediaDeleted.dates.selected) {
        case "always":
          this.filtersMediaDeleted.fromDate = new this.$moment('2021-01-01').format('YYYY-MM-DD');
          this.filtersMediaDeleted.toDate = now.format('YYYY-MM-DD');
          break;
        case "today":
          this.filtersMediaDeleted.fromDate = now.format('YYYY-MM-DD');
          this.filtersMediaDeleted.toDate = now.format('YYYY-MM-DD');
          break;
        case "yesterday":
          this.filtersMediaDeleted.fromDate = now.subtract(1, 'day').format('YYYY-MM-DD');
          this.filtersMediaDeleted.toDate = this.filtersMediaDeleted.fromDate;
          break;
        case "week":
          this.filtersMediaDeleted.toDate = now.format('YYYY-MM-DD');
          this.filtersMediaDeleted.fromDate = now.subtract(1, 'week').startOf('day').format('YYYY-MM-DD');
          break;
        case "curMonth":
          this.filtersMediaDeleted.toDate = now.format('YYYY-MM-DD');
          this.filtersMediaDeleted.fromDate = now.startOf('month').format('YYYY-MM-DD');
          break;
        case "last30Day":
          this.filtersMediaDeleted.toDate = now.format('YYYY-MM-DD');
          this.filtersMediaDeleted.fromDate = now.subtract(30, 'day').startOf('day').format('YYYY-MM-DD');
          break;
        case "lastMonth":
          this.filtersMediaDeleted.fromDate = now.subtract(1, 'month').startOf('month').format('YYYY-MM-DD');
          this.filtersMediaDeleted.toDate = now.endOf('month').format('YYYY-MM-DD');
          break;
        case "last3Month":
          this.filtersMediaDeleted.toDate = now.format('YYYY-MM-DD');
          this.filtersMediaDeleted.fromDate = now.subtract(3, 'month').startOf('day').format('YYYY-MM-DD');
          break;
        case "curYear":
          this.filtersMediaDeleted.toDate = now.format('YYYY-MM-DD');
          this.filtersMediaDeleted.fromDate = now.startOf('year').format('YYYY-MM-DD');
          break;
        case "custom":
          this.filtersMediaDeleted.fromDate = null;
          this.filtersMediaDeleted.toDate = null;
          break;
      }
    },

    handleUpdatesDateChange() {
      let now = new this.$moment();
      switch(this.filtersUpdates.dates.selected) {
        case "always":
          this.filtersUpdates.fromDate = new this.$moment('2021-01-01').format('YYYY-MM-DD');
          this.filtersUpdates.toDate = now.format('YYYY-MM-DD');
          break;
        case "today":
          this.filtersUpdates.fromDate = now.format('YYYY-MM-DD');
          this.filtersUpdates.toDate = now.format('YYYY-MM-DD');
          break;
        case "yesterday":
          this.filtersUpdates.fromDate = now.subtract(1, 'day').format('YYYY-MM-DD');
          this.filtersUpdates.toDate = this.filtersUpdates.fromDate;
          break;
        case "week":
          this.filtersUpdates.toDate = now.format('YYYY-MM-DD');
          this.filtersUpdates.fromDate = now.subtract(1, 'week').startOf('day').format('YYYY-MM-DD');
          break;
        case "curMonth":
          this.filtersUpdates.toDate = now.format('YYYY-MM-DD');
          this.filtersUpdates.fromDate = now.startOf('month').format('YYYY-MM-DD');
          break;
        case "last30Day":
          this.filtersUpdates.toDate = now.format('YYYY-MM-DD');
          this.filtersUpdates.fromDate = now.subtract(30, 'day').startOf('day').format('YYYY-MM-DD');
          break;
        case "lastMonth":
          this.filtersUpdates.fromDate = now.subtract(1, 'month').startOf('month').format('YYYY-MM-DD');
          this.filtersUpdates.toDate = now.endOf('month').format('YYYY-MM-DD');
          break;
        case "last3Month":
          this.filtersUpdates.toDate = now.format('YYYY-MM-DD');
          this.filtersUpdates.fromDate = now.subtract(3, 'month').startOf('day').format('YYYY-MM-DD');
          break;
        case "curYear":
          this.filtersUpdates.toDate = now.format('YYYY-MM-DD');
          this.filtersUpdates.fromDate = now.startOf('year').format('YYYY-MM-DD');
          break;
        case "custom":
          this.filtersUpdates.fromDate = null;
          this.filtersUpdates.toDate = null;
          break;
      }
    },

    handleProfilesDateChange() {
      let now = new this.$moment();
      switch(this.filtersUpdates.dates.selected) {
        case "always":
          this.filtersProfiles.fromDate = new this.$moment('2021-01-01').format('YYYY-MM-DD');
          this.filtersProfiles.toDate = now.format('YYYY-MM-DD');
          break;
        case "today":
          this.filtersProfiles.fromDate = now.format('YYYY-MM-DD');
          this.filtersProfiles.toDate = now.format('YYYY-MM-DD');
          break;
        case "yesterday":
          this.filtersProfiles.fromDate = now.subtract(1, 'day').format('YYYY-MM-DD');
          this.filtersProfiles.toDate = this.filtersProfiles.fromDate;
          break;
        case "week":
          this.filtersProfiles.toDate = now.format('YYYY-MM-DD');
          this.filtersProfiles.fromDate = now.subtract(1, 'week').startOf('day').format('YYYY-MM-DD');
          break;
        case "curMonth":
          this.filtersProfiles.toDate = now.format('YYYY-MM-DD');
          this.filtersProfiles.fromDate = now.startOf('month').format('YYYY-MM-DD');
          break;
        case "last30Day":
          this.filtersProfiles.toDate = now.format('YYYY-MM-DD');
          this.filtersProfiles.fromDate = now.subtract(30, 'day').startOf('day').format('YYYY-MM-DD');
          break;
        case "lastMonth":
          this.filtersProfiles.fromDate = now.subtract(1, 'month').startOf('month').format('YYYY-MM-DD');
          this.filtersProfiles.toDate = now.endOf('month').format('YYYY-MM-DD');
          break;
        case "last3Month":
          this.filtersProfiles.toDate = now.format('YYYY-MM-DD');
          this.filtersProfiles.fromDate = now.subtract(3, 'month').startOf('day').format('YYYY-MM-DD');
          break;
        case "curYear":
          this.filtersProfiles.toDate = now.format('YYYY-MM-DD');
          this.filtersProfiles.fromDate = now.startOf('year').format('YYYY-MM-DD');
          break;
        case "custom":
          this.filtersProfiles.fromDate = null;
          this.filtersProfiles.toDate = null;
          break;
      }
    },

    getRequestParamsMedia(page, pageSize) {
      let params = {};
      params["page"] = page - 1;
      params["size"] = pageSize;
      params["operator"] = this.filtersMedia.operators.selected;
      params["mediaType"] = this.filtersMedia.mediaTypes.selected;
      params["gender"] = this.filtersMedia.gender.selected;

      if (this.filtersMedia.selected === 'custom' && this.filtersMedia.dates.dateRange !== null) {
        this.filtersMedia.fromDate = this.$moment(this.filtersMedia.dates.dateRange[0]).format("YYYY-MM-DD 00:00:00");
        this.filtersMedia.toDate = this.$moment(this.filtersMedia.dates.dateRange[1]).format("YYYY-MM-DD 23:59:59");
      }
      else if (this.filtersMedia.fromDate === null)
        this.handleMediaDateChange();

      params["fromDate"] = this.filtersMedia.fromDate || '';
      params["toDate"] = this.filtersMedia.toDate || '';

      return params;
    },

    getRequestParamsMediaScored(page, pageSize) {
      let params = {};
      params["page"] = page - 1;
      params["size"] = pageSize;
      params["operator"] = this.filtersMediaScored.operators.selected;
      params["mediaType"] = this.filtersMediaScored.mediaTypes.selected;
      params["gender"] = this.filtersMediaScored.gender.selected;
      params["score"] = this.filtersMediaScored.mediaScore.selected;
      params["usersType"] = this.filtersMediaScored.userTypes.selected;
      params["toCheck"] = this.filtersMediaScored.toChecked.selected;

      if (this.filtersMediaScored.selected === 'custom' && this.filtersMediaScored.dates.dateRange !== null) {
        this.filtersMediaScored.fromDate = this.$moment(this.filtersMediaScored.dates.dateRange[0]).format("YYYY-MM-DD 00:00:00");
        this.filtersMediaScored.toDate = this.$moment(this.filtersMediaScored.dates.dateRange[1]).format("YYYY-MM-DD 23:59:59");
      }
      else if (this.filtersMediaScored.fromDate === null)
        this.handleMediaScoredDateChange();

      params["fromDate"] = this.filtersMediaScored.fromDate || '';
      params["toDate"] = this.filtersMediaScored.toDate || '';

      return params;
    },

    getRequestParamsMediaDeleted(page, pageSize) {
      let params = {};
      params["page"] = page - 1;
      params["size"] = pageSize;
      params["operator"] = this.filtersMediaDeleted.operators.selected;
      params["mediaType"] = this.filtersMediaDeleted.mediaTypes.selected;
      params["gender"] = this.filtersMediaDeleted.gender.selected;

      if (this.filtersMediaDeleted.dates.selected === 'custom' && this.filtersMediaDeleted.dates.dateRange !== null) {
        this.filtersMediaDeleted.fromDate = this.$moment(this.filtersMediaDeleted.dates.dateRange[0]).format("YYYY-MM-DD 00:00:00");
        this.filtersMediaDeleted.toDate = this.$moment(this.filtersMediaDeleted.dates.dateRange[1]).format("YYYY-MM-DD 23:59:59");
      }
      else if (this.filtersMediaDeleted.fromDate === null)
        this.handleMediaDeletedDateChange();

      params["fromDate"] = this.filtersMediaDeleted.fromDate || '';
      params["toDate"] = this.filtersMediaDeleted.toDate || '';

      return params;
    },

    getRequestParamsUpdates(page, pageSize) {
      let params = {};
      params["page"] = page - 1;
      params["size"] = pageSize;
      params["operator"] = this.filtersUpdates.operators.selected;

      if (this.filtersUpdates.selected === 'custom' && this.filtersUpdates.dates.dateRange !== null) {
        this.filtersUpdates.fromDate = this.$moment(this.filtersUpdates.dates.dateRange[0]).format("YYYY-MM-DD 00:00:00");
        this.filtersUpdates.toDate = this.$moment(this.filtersUpdates.dates.dateRange[1]).format("YYYY-MM-DD 23:59:59");
      }
      else if (this.filtersUpdates.fromDate === null)
        this.handleUpdatesDateChange();

      params["fromDate"] = this.filtersUpdates.fromDate || '';
      params["toDate"] = this.filtersUpdates.toDate || '';

      return params;
    },

    getRequestParamsProfiles(page, pageSize) {
      let params = {};
      params["page"] = page - 1;
      params["size"] = pageSize;
      params["operator"] = this.filtersProfiles.operators.selected;

      if (this.filtersProfiles.selected === 'custom' && this.filtersProfiles.dates.dateRange !== null) {
        this.filtersProfiles.fromDate = this.$moment(this.filtersProfiles.dates.dateRange[0]).format("YYYY-MM-DD 00:00:00");
        this.filtersProfiles.toDate = this.$moment(this.filtersProfiles.dates.dateRange[1]).format("YYYY-MM-DD 23:59:59");
      }
      else if (this.filtersProfiles.fromDate === null)
        this.handleProfilesDateChange();

      params["fromDate"] = this.filtersProfiles.fromDate || '';
      params["toDate"] = this.filtersProfiles.toDate || '';

      return params;
    },

    processFiltersMedia() {
      this.loadedMedia = true;
      this.isLoadingMedia = true;
      const params = this.getRequestParamsMedia(
          this.pageMedia,
          this.pageSizes.selected
      );

      if (this.media.length > 0) {
        this.deleteMediaItems();
        this.imagesCountMedia = 0;
      }

      MediaDataService.getModerationMedia(params)
          .then(response => {
            const { items, totalItems } = response.data;
            if (items.length > 0) {
              items.forEach(item => {
                item.src = '';
                item.thumb = '';
                item.title =  new Date(item.createdAt).toLocaleString()+ " - media #"+item.rankMedia;
                item.description = item.name + ' #'+item.userId;
                item.isVideo = item.typeMedia === 1;
                this._loadMedia(item);
              });
            }
            this.countMedia = totalItems;
            this.isLoadingMedia = false;
          })
          .catch(e => {
            this.isLoadingMedia = false;
            window.console.error("loadMedia failed...", e);
          });
    },

    processFiltersMediaScored() {
      this.loadedMediaScored = true;
      this.isLoadingMediaScored = true;
      const params = this.getRequestParamsMediaScored(
          this.pageMediaScored,
          this.pageSizes.selected
      );

      if (this.mediaScored.length > 0) {
        this.deleteMediaScoredItems();
        this.imagesCountMediaScored = 0;
      }

      MediaDataService.getModerationMediaScored(params)
          .then(response => {
            const { items, totalItems } = response.data;
            if (items.length > 0) {
              items.forEach(item => {
                item.src = '';
                item.thumb = '';
                item.title =  new Date(item.createdAt).toLocaleString()+ " - media #"+item.rankMedia;
                item.description = item.name + ' #'+item.userId;
                item.isVideo = item.typeMedia === 1;
                this._loadMediaScored(item);
              });
            }
            this.countMediaScored = totalItems;
            this.isLoadingMediaScored = false;
          })
          .catch(e => {
            this.isLoadingMediaScored = false;
            window.console.error("loadMedia scored failed...", e);
          });
    },

    rendered (mediaId) {
      this.imagesCountMedia++

      let elt = document.getElementById(mediaId).parentNode;
      this.resizeMasonryItem(elt);
    },

    renderedDeleted (mediaId) {
      this.imagesCountMediaDeleted++

      let elt = document.getElementById(mediaId).parentNode;
      this.resizeMasonryItemDeleted(elt);
    },

    renderedScored (mediaId) {
      this.imagesCountMediaScored++

      let elt = document.getElementById(mediaId).parentNode;
      this.resizeMasonryItemScored(elt);
    },

    resizeMasonryItem (item) {
      /* Get the grid object, its row-gap, and the size of its implicit rows */
      let grid = document.getElementsByClassName('masonry')[0],
          rowGap = parseInt(window.getComputedStyle(grid).getPropertyValue('grid-row-gap')),
          rowHeight = parseInt(window.getComputedStyle(grid).getPropertyValue('grid-auto-rows'));

      /*
       * Spanning for any brick = S
       * Grid's row-gap = G
       * Size of grid's implicitly create row-track = R
       * Height of item content = H
       * Net height of the item = H1 = H + G
       * Net height of the implicit row-track = T = G + R
       * S = H1 / T
       */

      let rowSpan = Math.ceil((item.querySelector('.media-item-content').getBoundingClientRect().height + rowGap) / (rowHeight + rowGap));

      /* Set the spanning as calculated above (S) */
      item.style.gridRowEnd = 'span ' + rowSpan;
    },

    resizeMasonryItemScored (item) {
      /* Get the grid object, its row-gap, and the size of its implicit rows */
      let grid = document.getElementsByClassName('masonry-scored')[0],
          rowGap = parseInt(window.getComputedStyle(grid).getPropertyValue('grid-row-gap')),
          rowHeight = parseInt(window.getComputedStyle(grid).getPropertyValue('grid-auto-rows'));

      /*
       * Spanning for any brick = S
       * Grid's row-gap = G
       * Size of grid's implicitly create row-track = R
       * Height of item content = H
       * Net height of the item = H1 = H + G
       * Net height of the implicit row-track = T = G + R
       * S = H1 / T
       */

      let rowSpan = Math.ceil((item.querySelector('.media-item-content').getBoundingClientRect().height + rowGap) / (rowHeight + rowGap));

      /* Set the spanning as calculated above (S) */
      item.style.gridRowEnd = 'span ' + rowSpan;
    },

    resizeMasonryItemDeleted (item) {
      /* Get the grid object, its row-gap, and the size of its implicit rows */
      let grid = document.getElementsByClassName('masonry-deleted')[0],
          rowGap = parseInt(window.getComputedStyle(grid).getPropertyValue('grid-row-gap')),
          rowHeight = parseInt(window.getComputedStyle(grid).getPropertyValue('grid-auto-rows'));

      /*
       * Spanning for any brick = S
       * Grid's row-gap = G
       * Size of grid's implicitly create row-track = R
       * Height of item content = H
       * Net height of the item = H1 = H + G
       * Net height of the implicit row-track = T = G + R
       * S = H1 / T
       */

      let rowSpan = Math.ceil((item.querySelector('.media-item-content').getBoundingClientRect().height + rowGap) / (rowHeight + rowGap));

      /* Set the spanning as calculated above (S) */
      item.style.gridRowEnd = 'span ' + rowSpan;
    },

    deleteMediaItems() {
      document.querySelectorAll('.media-valided.media-item').forEach(elt => {
        elt.remove();
      });
      this.media.splice(0, this.media.length);
    },

    deleteMediaScoredItems() {
      document.querySelectorAll('.media-scored.media-item').forEach(elt => {
        elt.remove();
      });
      this.mediaScored.splice(0, this.mediaScored.length);
    },

    deleteMediaDeletedItems() {
      document.querySelectorAll('.media-deleted.media-item').forEach(elt => {
        elt.remove();
      });
      this.mediaDeleted.splice(0, this.mediaDeleted.length);
    },

    resizeAllMasonryItems () {
      // Get all item class objects in one list
      let allItems = document.getElementsByClassName('media-valided media-item');
      /*
       * Loop through the above list and execute the spanning function to
       * each list-item (i.e. each masonry item)
       */
      for (let i = 0; i < allItems.length; i++) {
        this.resizeMasonryItem(allItems[i]);
      }
    },

    resizeAllMasonryItemsScored () {
      // Get all item class objects in one list
      let allItems = document.getElementsByClassName('media-scored media-item');
      /*
       * Loop through the above list and execute the spanning function to
       * each list-item (i.e. each masonry item)
       */
      for (let i = 0; i < allItems.length; i++) {
        this.resizeMasonryItemScored(allItems[i]);
      }
    },

    resizeAllMasonryItemsDeleted () {
      // Get all item class objects in one list
      let allItems = document.getElementsByClassName('media-deleted media-item');
      /*
       * Loop through the above list and execute the spanning function to
       * each list-item (i.e. each masonry item)
       */
      for (let i = 0; i < allItems.length; i++) {
        this.resizeMasonryItemDeleted(allItems[i]);
      }
    },

    _loadMedia(item) {

      const promises = [];

      if (!item.isVideo) {
        if (item.isValid) {
          promises.push(Storage.getUserMediaUrl(item.userId, item.mediaId));
        } else {
          promises.push(Storage.getUserMediaUrl(item.userId, item.mediaId+'.origin'));
        }
      }
      else if (item.isVideo) {
        promises.push(Storage.getUserMediaUrl(item.userId, item.thumbFileName));
        promises.push(Storage.getUserMediaUrl(item.userId, item.mediaId));
      }

      const that = this;
      Promise.all(promises)
          .then(values => {
            if (values.length === 1) {
              item.thumb = item.src = values[0];
            } else {
              item.thumb = values[0];
              item.src = values[1];
            }

            let img = new Image();
            img.crossOrigin = "anonymous";
            img.onload = function() {
              item.width = img.width;
              item.height = img.height;
              item.imgObj = img;
              that.media.push(item);
            };
            img.src = item.thumb;
          })
          .catch (error => {
            window.console.error(error);
            let img = new Image();
            img.crossOrigin = "anonymous";
            img.onload = function() {
              item.width = img.width;
              item.height = img.height;
              item.imgObj = img;
              that.media.push(item);
            };
            img.src = require("@/assets/images/users/error.png");
          });
    },

    _loadMediaScored(item) {

      const promises = [];

      if (!item.isVideo) {
        if (item.isValid) {
          promises.push(Storage.getUserMediaUrl(item.userId, item.mediaId));
        } else {
          promises.push(Storage.getUserMediaUrl(item.userId, item.mediaId+'.origin'));
        }
      }
      else if (item.isVideo) {
        promises.push(Storage.getUserMediaUrl(item.userId, item.thumbFileName));
        promises.push(Storage.getUserMediaUrl(item.userId, item.mediaId));
      }

      const that = this;
      Promise.all(promises)
          .then(values => {
            if (values.length === 1) {
              item.thumb = item.src = values[0];
            } else {
              item.thumb = values[0];
              item.src = values[1];
            }

            let img = new Image();
            img.crossOrigin = "anonymous";
            img.onload = function() {
              item.width = img.width;
              item.height = img.height;
              item.imgObj = img;
              that.mediaScored.push(item);
            };
            img.src = item.thumb;
          })
          .catch (error => {
            window.console.error(error);
            let img = new Image();
            img.crossOrigin = "anonymous";
            img.onload = function() {
              item.width = img.width;
              item.height = img.height;
              item.imgObj = img;
              that.mediaScored.push(item);
            };
            img.src = require("@/assets/images/users/error.png");
          });
    },

    _loadMediaDeleted(item) {

      const promises = [];

      if (!item.isVideo) {
        if (item.isValid) {
          promises.push(Storage.getUserMediaDeletedUrl(item.userId, item.mediaId));
        } else {
          promises.push(Storage.getUserMediaDeletedUrl(item.userId, item.mediaId+'.origin'));
        }
      }
      else if (item.isVideo) {
        promises.push(Storage.getUserMediaDeletedUrl(item.userId, item.thumbFileName));
        promises.push(Storage.getUserMediaDeletedUrl(item.userId, item.mediaId));
      }

      const that = this;
      Promise.all(promises)
          .then(values => {
            if (values.length === 1) {
              item.thumb = item.src = values[0];
            } else {
              item.thumb = values[0];
              item.src = values[1];
            }

            let img = new Image();
            img.crossOrigin = "anonymous";
            img.onload = function() {
              item.width = img.width;
              item.height = img.height;
              item.imgObj = img;
              that.mediaDeleted.push(item);
            };
            img.src = item.thumb;
          })
          .catch (error => {
            window.console.error(error);
            let img = new Image();
            img.crossOrigin = "anonymous";
            img.onload = function() {
              item.width = img.width;
              item.height = img.height;
              item.imgObj = img;
              that.mediaDeleted.push(item);
            };
            img.src = require("@/assets/images/users/error.png");
          });
    },

    mediaClick(value, index) {
      this.indexMedia = index;
    },

    mediaDeletedClick(value, index) {
      this.indexMediaDeleted = index;
    },

    mediaScoredClick(value, index) {
      this.indexMediaScored = index;
    },

    async reimportMedia(media) {
      let parent = document.getElementById(media.mediaId);
      let loadingElt = parent.getElementsByClassName('media-item-loading')[0];
      loadingElt.classList.toggle('d-none');
      try {
        await MediaDataService.reimportMedia({
          userId: media.userId,
          mediaId: media.mediaId
        });
        await AdminUtils.addAction({
          adminId: this.getUser.uid,
          category: 'media',
          type: 'unarchive',
          userId: media.userId,
          data1: media.mediaId
        });

        loadingElt.classList.toggle('d-none');
        this.$toast.success(this.$t('media.media_valid_success'));
        media.isValid = true;
        this.countMediaDeleted--;
        let idx = this.mediaDeleted.findIndex(m => m.mediaId === media.mediaId);
        if (idx > -1) this.mediaDeleted.splice(idx, 1);
        this.resizeAllMasonryItemsDeleted();
      }
      catch (error) {
        loadingElt.classList.toggle('d-none');
        window.console.error("MediaDataService.reimportMedia failed", media, error);
        this.$toast.error(error);
      }
    },

    async deleteMedia(media) {
      let parent = document.getElementById(media.mediaId);
      let loadingElt = parent.getElementsByClassName('media-item-loading')[0];
      loadingElt.classList.toggle('d-none');

      await MediaDataService.archiveMedia({
        userId: media.userId,
        mediaId: media.mediaId,
        adminId: this.getUser.uid,
      });

      UserUtils.deleteMedia(media.userId, media)
          .then(async () => {
            await AdminUtils.addAction({
              adminId: this.getUser.uid,
              category: 'media',
              type: 'delete',
              userId: media.userId,
              data1: media.mediaId
            });
            this.countMedia--;
            loadingElt.classList.toggle('d-none');
            this.$toast.success(this.$t('media.media_delete_success'));
            let idx = this.media.findIndex(m => m.mediaId === media.mediaId);
            if (idx > -1) this.media.splice(idx, 1);

            // reset media rank for user
            this.media.find(m => m.userId === media.userId).forEach(elt => {
              if (elt.rankMedia > media.rankMedia)
                elt.rankMedia--;
            });
            this.resizeAllMasonryItems();
          })
          .catch(error => {
            loadingElt.classList.toggle('d-none');
            window.console.error("UserUtils.deleteMedia", media, error);
            this.$toast.error(error);
          })
    },

    markAsVerified(media) {
      const params = {
        userId: media.userId,
        adminId: this.getUser.uid,
        score: media.mediaScore,
        userGroup: media.userGroup,
        type: media.typeMedia,
        rank: media.rankMedia
      };

      let parent = document.getElementById('scored-' + media.mediaId);
      let loadingElt = parent.getElementsByClassName('media-item-loading')[0];
      loadingElt.classList.toggle('d-none');
      return MediaDataService
          .markAsVerified(media.mediaId, params)
          .then(() => {
            media.mediaScoreAt = new Date().toISOString().slice(0, 19).replace('T', ' ');
            media.mediaScoreBy = this.getUser.displayName;
          })
          .catch((error) => {
            this.$toast.error(error.toString());
            window.console.error(error);
          })
          .finally(() => {
            setTimeout(function() { loadingElt.classList.toggle('d-none'); }, 1500);
          });
    },

    processFiltersMediaDeleted() {
      this.loadedMediaDeleted = true;
      this.isLoadingMediaDeleted = true;
      const params = this.getRequestParamsMediaDeleted(
          this.pageMediaDeleted,
          this.pageSizes.selected
      );
      if (this.mediaDeleted.length > 0) {
        this.deleteMediaDeletedItems();
        this.imagesCountMediaDeleted = 0;
      }

      MediaDataService.getModerationMediaDeleted(params)
          .then(response => {
            const { items, totalItems } = response.data;
            if (items.length > 0) {
              items.forEach(item => {
                item.src = '';
                item.thumb = '';
                item.title =  new Date(item.createdAt).toLocaleString()+ " - media #"+item.rankMedia;
                item.description = item.name + ' #'+item.userId;
                item.isVideo = item.typeMedia === 1;
                this._loadMediaDeleted(item);
              });
            }
            this.countMediaDeleted = totalItems;
            this.isLoadingMediaDeleted = false;
          })
          .catch(e => {
            this.isLoadingMediaDeleted = false;
            window.console.error("loadMedia failed...", e);
          });
    },

    processFiltersUpdates() {
      this.loadedUpdates = true;
      this.isLoadingUpdates = true;
      const params = this.getRequestParamsUpdates(
          this.pageUpdates,
          this.pageSizes.selected
      );

      UsersDataService.getModerationUpdates(params)
          .then(response => {
            const { items, totalItems } = response.data;
            const users = [];
            if (items.length > 0) {
              for (const item of items) {
                users.push(UserUtils.normalizeUpdates(item));
              }
            }

            this.updates = users;
            this.countUpdates = totalItems;
            this.getMediaThumbUpdates();
            this.isLoadingUpdates = false;
          })
          .catch(error => {
            this.isLoadingUpdates = false;
            window.console.error(error);
            this.$toast.error(error.message);
          })
    },

    getMediaThumbUpdates() {
      if (this.updates.length > 0)
        this.updates.forEach(user => {
          if (user.photo && user.photo.length > 0)
            Storage.getUserMedia(user.userId, user.photo, "verify-member-" + user.documentId);
        });
    },

    processFiltersProfiles() {
      this.loadedProfiles = true;
      this.isLoadingProfiles = true;
      const params = this.getRequestParamsProfiles(
          this.pageProfiles,
          this.pageSizes.selected
      );

      UsersDataService.getModerationProfiles(params)
          .then(response => {
            const { items, totalItems } = response.data;
            const users = [];
            if (items.length > 0) {
              for (const item of items) {
                users.push(UserUtils.normalize(item));
              }
            }

            this.profiles = users;
            this.countProfiles = totalItems;
            this.getMediaThumbProfiles();
            this.isLoadingProfiles = false;
          })
          .catch(error => {
            this.isLoadingProfiles = false;
            window.console.error(error);
            this.$toast.error(error.message);
          })
    },

    getMediaThumbProfiles() {
      if (this.profiles.length > 0)
        this.profiles.forEach(user => {
          if (user.photo && user.photo.length > 0)
            Storage.getUserMedia(user.userId, user.photo, user.userId+'-img');
          if (user.video && user.video.length > 0)
            Storage.getUserMedia(user.userId, user.video, user.userId+'-video');
        });
    },

    getCountry(user) {
      return UserUtils.getCountryName(countriesISO, user.country.toUpperCase(), this.$i18n.locale)
    },

    setScoreChecked() {
      this.isLoadingMediaScored = true;
      const params = {
        adminId: this.getUser.uid,
      };

      const checkedList = [];
      this.mediaScored.forEach(result => {
        checkedList.push({
          mediaId: result.mediaId,
          userId: result.userId,
          type: result.typeMedia,
          userGroup: result.userGroup,
          rank: result.rankMedia
        })
      });

      params.checkedList = checkedList;

      return MediaDataService
          .markAsScoreVerified(params)
          .then(async () => {
            this.isLoadingMediaScored = false;
            this.page = 1;
            this.processFiltersMediaScored();
          })
          .catch((error) => {
            this.isLoadingMediaScored = false;
            this.$toast.error(error.toString());
            window.console.error(error);
          });
    },

    /* User profile */
    openUserPane() {
      if (!this.isUserPaneDisplayed)
        this.isUserPaneDisplayed = true;
    },

    closeUserPane() {
      this.userTabsActive = '';
      this.isUserPaneDisplayed = false;
    },

    async showUser(userId) {
      const isUserAlreadyDisplayed = this.userTabs.findIndex(x => x.userId === userId);
      let forceShow = false;
      if (isUserAlreadyDisplayed === -1) {
        try {
          const result = await UsersDataService.get(userId);
          if (typeof result.data === 'undefined')
            throw new Error('unable to find user '+userId);

          this.userTabs.push(UserUtils.normalize(result.data));
          forceShow = true;
        }
        catch (error) {
          window.console.error(error);
          this.$toast.error(this.$t("global_error"));
        }
      }

      this.openUserPane();

      if (forceShow || (!forceShow && this.userTabsActive !== userId)) {
        this.userTabsActive = '';
        setTimeout(() => { this.userTabsActive = userId; }, 100);
      }
    },

    showMedia(user, type) {
      const mediaId = String(type === 0 ? user.photo : user.video.replace(".jpg", ".mp4")).replace("th_", "");
      Storage.getUserMediaUrl(user.userId, mediaId)
          .then((url) => {
            const media = {
              "id": 1,
              "userId": user.userId,
              "mediaId": mediaId,
              "createdAt":"",
              "typeMedia": type,
              "src": url,
              "title":"1/1",
            };

            this.showUserMedia([media], 0);
          });
    },

    showUserMedia(media, index) {
      this.userMedia.media = media;
      this.userMedia.index = index;
    },

    removeUserTab(userId) {
      const index = this.userTabs.findIndex(x => x.userId === userId);
      if (index > -1)
        this.userTabs.splice(index, 1);

      if (this.userTabs.length === 0)
        this.closeUserPane();
    }
  },

  data() {
    return {
      tabIndex:0,
      indexMedia: null,
      indexMediaDeleted: null,
      indexMediaScored: null,

      media: [],
      mediaScored: [],
      mediaDeleted: [],
      updates: [],
      profiles: [],

      imagesCountMedia: 0,
      imagesCountMediaDeleted: 0,
      imagesCountMediaScored: 0,

      pageMedia: 1,
      pageMediaDeleted: 1,
      pageMediaScored: 1,
      pageUpdates: 1,
      pageProfiles: 1,

      countMedia: 0,
      countMediaDeleted: 0,
      countMediaScored: 0,
      countUpdates: 0,
      countProfiles: 0,

      isLoadingMedia: false,
      isLoadingMediaDeleted: false,
      isLoadingMediaScored: false,
      isLoadingUpdates: false,
      isLoadingProfiles: false,

      loadedMedia: false,
      loadedMediaDeleted: false,
      loadedMediaScored: false,
      loadedUpdates: false,
      loadedProfiles: false,

      mediaOptionsImage: [
        {text: '🤢 BAD', value: "L"},
        {text: '🙂 MOY', value: "M"},
        {text: '🤩 TOP', value: "H"},
      ],
      mediaOptionsVideo: [
        {text: 'normal', value: "M"},
        {text: 'featured', value: "H"},
      ],

      title: this.$t("menuitems.moderation.text"),
      pageSizes: {
        options: ['1', '5', '10', '50', '100', '200'],
        selected: '50'
      },
      pane: {
        installSize: 0
      },

      /* Filters */
      filtersMedia: {
        valid: true,
        fromDate: null,
        toDate: null,
        dates: {
          dateRange: null,
          selected: 'today',
          options: [
            {value:'today', text:this.$t("dates.today")},
            {value:'yesterday', text:this.$t("dates.yesterday")},
            {value:'week', text:this.$t("dates.week")},
            {value:'curMonth', text:this.$t("dates.curMonth")},
            {value:'last30Day', text:this.$t("dates.last30Day")},
            {value:'lastMonth', text:this.$t("dates.lastMonth")},
            {value:'last3Month', text:this.$t("dates.last3Month")},
            {value:'curYear', text:this.$t("dates.curYear")},
            {value:'always', text:this.$t("dates.always")},
            {value:'custom', text:this.$t("dates.custom")}
          ]
        },
        operators: {
          selected: 'all',
          options: [
            {value: 'all', text: this.$t("actions.operators_all")},
          ]
        },
        gender: {
          selected: 'all',
          options: [
            {value: "all", text: "All Gender"},
            {value: 1, text: 'Only Men'},
            {value: 2, text: 'Only Women'},
          ]
        },
        mediaTypes: {
          selected: 'all',
          options: [
            {value: "all", text: "All Media"},
            {value: 1, text: 'Only Videos'},
            {value: 0, text: 'Only Images'},
          ]
        },
      },
      filtersMediaScored: {
        valid: true,
        fromDate: null,
        toDate: null,
        dates: {
          dateRange: null,
          selected: 'today',
          options: [
            {value:'today', text:this.$t("dates.today")},
            {value:'yesterday', text:this.$t("dates.yesterday")},
            {value:'week', text:this.$t("dates.week")},
            {value:'curMonth', text:this.$t("dates.curMonth")},
            {value:'last30Day', text:this.$t("dates.last30Day")},
            {value:'lastMonth', text:this.$t("dates.lastMonth")},
            {value:'last3Month', text:this.$t("dates.last3Month")},
            {value:'curYear', text:this.$t("dates.curYear")},
            {value:'always', text:this.$t("dates.always")},
            {value:'custom', text:this.$t("dates.custom")}
          ]
        },
        operators: {
          selected: 'all',
          options: [
            {value: 'all', text: this.$t("actions.operators_all")},
          ]
        },
        userTypes: {
          selected: 'all',
          options: [
            {value: "all", text: "All Users"},
            {value: "R", text: "Reals"},
            {value: "NR", text: "Specials"},
            {value: "L", text: "Like"},
            {value: "S", text: "Spreedl"}
          ]
        },
        toChecked: {
          selected: 'all',
          options: [
            {value: "all", text: "All Checks"},
            {value: 0, text: "To check"},
            {value: 1, text: "Checked"},
          ]
        },
        gender: {
          selected: 'all',
          options: [
            {value: "all", text: "All Gender"},
            {value: 1, text: 'Only Men'},
            {value: 2, text: 'Only Women'},
          ]
        },
        mediaTypes: {
          selected: 'all',
          options: [
            {value: "all", text: "All Media"},
            {value: 1, text: 'Only Videos'},
            {value: 0, text: 'Only Images'},
          ]
        },
        mediaScore: {
          selected: 'all',
          options: [
            {value: "all", text: "All Scores"},
            {text: '🤢 BAD', value: "L"},
            {text: '🙂 MOY', value: "M"},
            {text: '🤩 TOP', value: "H"},
          ]
        },
      },
      filtersMediaDeleted: {
        valid: true,
        fromDate: null,
        toDate: null,
        dates: {
          dateRange: null,
          selected: 'today',
          options: [
            {value:'today', text:this.$t("dates.today")},
            {value:'yesterday', text:this.$t("dates.yesterday")},
            {value:'week', text:this.$t("dates.week")},
            {value:'curMonth', text:this.$t("dates.curMonth")},
            {value:'last30Day', text:this.$t("dates.last30Day")},
            {value:'lastMonth', text:this.$t("dates.lastMonth")},
            {value:'last3Month', text:this.$t("dates.last3Month")},
            {value:'curYear', text:this.$t("dates.curYear")},
            {value:'always', text:this.$t("dates.always")},
            {value:'custom', text:this.$t("dates.custom")}
          ]
        },
        operators: {
          selected: 'all',
          options: [
            {value: 'all', text: this.$t("actions.operators_all")},
          ]
        },
        gender: {
          selected: 'all',
          options: [
            {value: "all", text: "All Gender"},
            {value: 1, text: 'Only Men'},
            {value: 2, text: 'Only Women'},
          ]
        },
        mediaTypes: {
          selected: 'all',
          options: [
            {value: "all", text: "All Media"},
            {value: 1, text: 'Only Videos'},
            {value: 0, text: 'Only Images'},
          ]
        },
      },
      filtersUpdates: {
        fromDate: null,
        toDate: null,
        dates: {
          dateRange: null,
          selected: 'today',
          options: [
            {value:'today', text:this.$t("dates.today")},
            {value:'yesterday', text:this.$t("dates.yesterday")},
            {value:'week', text:this.$t("dates.week")},
            {value:'curMonth', text:this.$t("dates.curMonth")},
            {value:'last30Day', text:this.$t("dates.last30Day")},
            {value:'lastMonth', text:this.$t("dates.lastMonth")},
            {value:'last3Month', text:this.$t("dates.last3Month")},
            {value:'curYear', text:this.$t("dates.curYear")},
            {value:'always', text:this.$t("dates.always")},
            {value:'custom', text:this.$t("dates.custom")}
          ]
        },
        operators: {
          selected: 'all',
          options: [
            {value: 'all', text: this.$t("actions.operators_all")},
          ]
        }
      },
      filtersProfiles: {
        fromDate: null,
        toDate: null,
        dates: {
          dateRange: null,
          selected: 'today',
          options: [
            {value:'today', text:this.$t("dates.today")},
            {value:'yesterday', text:this.$t("dates.yesterday")},
            {value:'week', text:this.$t("dates.week")},
            {value:'curMonth', text:this.$t("dates.curMonth")},
            {value:'last30Day', text:this.$t("dates.last30Day")},
            {value:'lastMonth', text:this.$t("dates.lastMonth")},
            {value:'last3Month', text:this.$t("dates.last3Month")},
            {value:'curYear', text:this.$t("dates.curYear")},
            {value:'always', text:this.$t("dates.always")},
            {value:'custom', text:this.$t("dates.custom")}
          ]
        },
        operators: {
          selected: 'all',
          options: [
            {value: 'all', text: this.$t("actions.operators_all")},
          ]
        }
      },

      /* User profile */
      isUserPaneDisplayed: false,
      userTabs:[],
      userTabsActive: '',
      userMedia: {
        media: [],
        index: -1
      },
    }
  },

  mounted() {
    this.loadOperators();
    if (this.tabIndex === 0) {
      this.processFiltersMedia();
    }
    else if (this.tabIndex === 1) {
      this.processFiltersMediaDeleted();
    }
    else if (this.tabIndex === 2) {
      this.processFiltersMediaScored();
    }
    else if (this.tabIndex === 3) {
      this.processFiltersUpdates();
    }
    else if (this.tabIndex === 4) {
      this.processFiltersProfiles();
    }
  },

  created () {
    countriesISO.registerLocale(require("i18n-iso-countries/langs/"+this.$i18n.locale+".json"));

    let masonryEvents = ['load', 'resize'];
    let vm = this;
    masonryEvents.forEach(function (event) {
      window.addEventListener(event, vm.resizeAllMasonryItems);
      window.addEventListener(event, vm.resizeAllMasonryItemsDeleted);
      window.addEventListener(event, vm.resizeAllMasonryItemsScored);
    });
  },

  computed: {
    ...authComputed,

    isSpecial() {
      const role = getRole(this.getRole);
      return role === Role.Marketing || role === Role.Admin;
    }
  },

  watch: {
    tabIndex: function() {
      if (this.tabIndex === 0 && !this.loadedMedia) {
        this.processFiltersMedia();
      }
      else if (this.tabIndex === 1 && !this.loadedMediaDeleted) {
        this.processFiltersMediaDeleted();
      }
      else if (this.tabIndex === 2 && !this.loadedMediaScored) {
          this.processFiltersMediaScored();
      }
      else if (this.tabIndex === 3 && !this.loadedUpdates) {
        this.processFiltersUpdates();
      }
      else if (this.tabIndex === 4 && !this.loadedProfiles) {
        this.processFiltersProfiles();
      }
    },

    imagesCountMedia: function () {
      if (this.imagesCountMedia === this.media.length) {
        this.resizeAllMasonryItems();
      }
    },

    imagesCountMediaDeleted: function () {
      if (this.imagesCountMediaDeleted === this.mediaDeleted.length) {
        this.resizeAllMasonryItemsDeleted();
      }
    },

    imagesCountMediaScored: function () {
      if (this.imagesCountMediaScored === this.mediaScored.length) {
        this.resizeAllMasonryItemsDeleted();
      }
    }
  },
}

</script>

<template>
  <Layout>
    <PageHeader :title="title" />
    <div class="position-relative">
      <b-button
          class="position-fixed"
          style="top: 77px; right: 15px;z-index:150"
          v-show="!isUserPaneDisplayed && userTabs.length > 0"
          @click="openUserPane"
          variant="outline-primary">
        <i class="bx bxs-cog"></i> Show Panel
      </b-button>

      <b-tabs content-class="" v-model="tabIndex">

        <!-- Media Valided Check -->
        <b-tab>
          <template #title>
            <i class="far fa-user"></i> {{ $t('menuitems.moderation.media_valided') }}
          </template>
          <div class="card">
            <div class="card-body">
              <!-- Loader -->
              <div class="row d-flex justify-content-center">
                <vue-ellipse-progress
                    v-show="isLoadingMedia"
                    :loading="isLoadingMedia"
                    :angle="-90"
                    color="#50a5f1"
                    emptyColor="#999"
                    emptyColorFill="#f8f8fb"
                    :size="100"
                    :thickness="3"
                    :emptyThickness="2"
                    lineMode="out 2"
                    animation="bounce 700 400"
                    fontColor="#666"
                    :half="false"
                    class="mt-5 mb-5"
                    fontSize="1rem">
                </vue-ellipse-progress>
            </div>

              <!-- filters -->
              <b-form inline class="row gy-2 gx-3 align-items-center" @submit.stop.prevent>

                <!-- dates -->
                <div class="col-sm-auto d-flex">
                  <b-form-select
                      id="moderationMediaDatesFilter"
                      @change="handleMediaDateChange"
                      v-model="filtersMedia.dates.selected"
                      class="form-select me-lg-1"
                      :options="filtersMedia.dates.options">
                  </b-form-select>
                  <date-picker
                      v-show="filtersMedia.dates.selected === 'custom'"
                      lang="fr"
                      :placeholder="this.$t('choose_date_interval')"
                      type="date"
                      value-type="format"
                      show-week-number
                      v-model="filtersMedia.dates.dateRange"
                      class="me-lg-2"
                      range append-to-body ></date-picker>

                </div>

                <!-- Admin -->
                <div class="col-sm-auto">
                  <b-form-select
                      id="moderationAdminFilter"
                      v-model="filtersMedia.operators.selected"
                      class="form-select me-lg-1"
                  >
                    <option v-for="st in filtersMedia.operators.options" :key="st.value" :value="st.value">{{ st.text }}</option>
                  </b-form-select>
                </div>

                <!-- MediaType -->
                <div class="col-sm-auto">
                  <b-form-select
                      id="moderationMediaTypeFilter"
                      v-model="filtersMedia.mediaTypes.selected"
                      class="form-select me-lg-1"
                  >
                    <option v-for="st in filtersMedia.mediaTypes.options" :key="st.value" :value="st.value">{{ st.text }}</option>
                  </b-form-select>
                </div>

                <!-- Gender -->
                <div class="col-sm-auto">
                  <b-form-select
                      id="moderationMediaGenderFilter"
                      v-model="filtersMedia.gender.selected"
                      class="form-select me-lg-1"
                  >
                    <option v-for="st in filtersMedia.gender.options" :key="st.value" :value="st.value">{{ st.text }}</option>
                  </b-form-select>
                </div>

                <div class="col-sm-auto">
                  <b-button variant="primary" class="w-md" @click="processFiltersMedia">{{ $t("find") }}</b-button>
                </div>

              </b-form>
              <hr>

              <!-- Top list tools -->
              <div class="row mb-3" v-if="!isLoadingMedia && media.length > 0">
                <div class="col-lg-auto col-12">
                  <!-- Display settings -->
                  <b-select class="form-select d-inline w-auto m-1" v-model="pageSizes.selected" @change="handleMediaDisplayChange">
                    <option v-for="size in pageSizes.options" :key="size" :value="size">{{ size }} {{ $t('pageSize') }}</option>
                  </b-select>
                  {{ countMedia }} {{ $t('resultsCount') }}
                </div>
                <!-- Pagination -->
                <div class="col-lg-auto col-12">
                  <div class="m-1 pagination-rounded">
                    <b-pagination
                        v-model="pageMedia"
                        :total-rows="countMedia"
                        :per-page="pageSizes.selected"
                        first-number
                        last-number
                        @change="handleMediaPageChange"
                        class="mb-3 justify-content-center"
                    ></b-pagination>
                  </div>
                </div>
              </div>

              <!-- result -->
              <div class="row">
                <div class="col-12">

                  <div class="masonry">
                    <div v-for="(item, key) in media"
                         :key="key"
                         class="media-valided media-item">
                      <div class="media-item-content position-relative" :id="item.mediaId">
                        <img :src="item.thumb" class="media-thumb" @load="rendered(`${item.mediaId}`)" @click="mediaClick(item, key)" />
                        <div class="position-absolute top-0 w-100">
                          <div class="p-2 text-white text-center font-size-11" style="background:rgba(0, 0, 0, 0.5);" v-show="item.checked === '1'">
                            <i class="bx bx-check text-white"></i> {{ formatDate(item.checkedAt) }} - <b>{{ getInitials(item.checkedBy) }}</b>
                          </div>
                          <div class="float-end m-1">
                            <span class="text-secondary font-size-11 d-inline-block rounded-circle shadow p-1 bg-white">
                            #{{ item.rankMedia }}
                            </span>
                                    <span v-if="item.isVideo" class="text-secondary ms-1 d-inline-block rounded-circle shadow p-1 bg-white">
                              <img :src="require('@/assets/images/video-play.svg')" width="20"  />
                            </span>
                          </div>
                          <div
                              class="d-inline-block text-white p-1 rounded font-size-11 m-1"
                              :class="item.sex === 1 ? 'bg-info' : 'bg-female'"
                          >{{ item.name }}<br>
                            <span v-if="item.mediaScore === 'L'">🤢 BAD</span>
                            <span v-if="item.mediaScore === 'M'">🙂 MOY</span>
                            <span v-if="item.mediaScore === 'H'">🤩 TOP</span>
                          </div>

                        </div>
                        <div class="p-2" :class="!item.isValid ? 'bg-danger' : 'bg-white'">
                          <div class="d-flex justify-content-center mt-1">
                            <b-button class="rounded-circle ms-2 me-2 bg-white" variant="outline-danger" @click="deleteMedia(item)">
                              <b-icon icon="x" scale="1.5"></b-icon>
                            </b-button>
                            <b-button class="rounded-circle ms-2 me-2 bg-white" variant="outline-secondary" @click="showUser(item.userId)">
                              <b-icon icon="search" scale="1"></b-icon>
                            </b-button>
                          </div>
                        </div>

                        <div class="p-2 bg-light text-center text-muted font-size-10">
                          #<b>{{ item.mediaId }}</b>
                        </div>
                        <div class="media-item-loading d-none"><i class="bx bx-loader-circle bx-spin"></i></div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>

              <!-- bottom list tools -->
              <div class="row mb-3" v-if="!isLoadingMedia && media.length > 0">
                <!-- Display settings -->
                <div class="col-lg-auto col-12">
                  <b-select class="form-select d-inline w-auto m-1" v-model="pageSizes.selected" @change="handleMediaDisplayChange">
                    <option v-for="size in pageSizes.options" :key="size" :value="size">{{ size }} {{ $t('pageSize') }}</option>
                  </b-select>
                </div>
                <!-- Pagination -->
                <div class="col-lg-auto col-12">
                  <div class="m-1 pagination-rounded">
                    <b-pagination
                        v-model="pageMedia"
                        :total-rows="countMedia"
                        :per-page="pageSizes.selected"
                        first-number
                        last-number
                        @change="handleMediaPageChange"
                        aria-controls="users-list"
                    ></b-pagination>
                  </div>
                </div>
              </div>


            </div>
          </div>
        </b-tab>

        <!-- Media Deleted Check -->
        <b-tab>
          <template #title>
            <i class="far fa-user"></i> {{ $t('menuitems.moderation.media_deleted') }}
          </template>
          <div class="card">
            <div class="card-body">
              <!-- Loader -->
              <div class="row d-flex justify-content-center">
                <vue-ellipse-progress
                    v-show="isLoadingMediaDeleted"
                    :loading="isLoadingMediaDeleted"
                    :angle="-90"
                    color="#50a5f1"
                    emptyColor="#999"
                    emptyColorFill="#f8f8fb"
                    :size="100"
                    :thickness="3"
                    :emptyThickness="2"
                    lineMode="out 2"
                    animation="bounce 700 400"
                    fontColor="#666"
                    :half="false"
                    class="mt-5 mb-5"
                    fontSize="1rem">
                </vue-ellipse-progress>
              </div>

              <!-- filters -->
              <b-form inline class="row gy-2 gx-3 align-items-center" @submit.stop.prevent>

                <!-- dates -->
                <div class="col-sm-auto d-flex">
                  <b-form-select
                      id="moderationMediaDeletedDatesFilter"
                      @change="handleMediaDeletedDateChange"
                      v-model="filtersMediaDeleted.dates.selected"
                      class="form-select me-lg-1"
                      :options="filtersMediaDeleted.dates.options">
                  </b-form-select>
                  <date-picker
                      v-show="filtersMediaDeleted.dates.selected === 'custom'"
                      lang="fr"
                      :placeholder="this.$t('choose_date_interval')"
                      type="date"
                      value-type="format"
                      show-week-number
                      v-model="filtersMediaDeleted.dates.dateRange"
                      class="me-lg-2"
                      range append-to-body ></date-picker>

                </div>

                <!-- Admin -->
                <div class="col-sm-auto">
                  <b-form-select
                      id="moderationMediaDeletedAdminFilter"
                      v-model="filtersMediaDeleted.operators.selected"
                      class="form-select me-lg-1"
                  >
                    <option v-for="st in filtersMediaDeleted.operators.options" :key="st.value" :value="st.value">{{ st.text }}</option>
                  </b-form-select>
                </div>

                <!-- MediaType -->
                <div class="col-sm-auto">
                  <b-form-select
                      id="moderationMediaDeletedTypeFilter"
                      v-model="filtersMediaDeleted.mediaTypes.selected"
                      class="form-select me-lg-1"
                  >
                    <option v-for="st in filtersMediaDeleted.mediaTypes.options" :key="st.value" :value="st.value">{{ st.text }}</option>
                  </b-form-select>
                </div>

                <!-- Gender -->
                <div class="col-sm-auto">
                  <b-form-select
                      id="moderationMediaDeletedGenderFilter"
                      v-model="filtersMediaDeleted.gender.selected"
                      class="form-select me-lg-1"
                  >
                    <option v-for="st in filtersMediaDeleted.gender.options" :key="st.value" :value="st.value">{{ st.text }}</option>
                  </b-form-select>
                </div>

                <div class="col-sm-auto">
                  <b-button variant="primary" class="w-md" @click="processFiltersMediaDeleted">{{ $t("find") }}</b-button>
                </div>

              </b-form>
              <hr>

              <!-- Top list tools -->
              <div class="row mb-3" v-if="!isLoadingMediaDeleted && mediaDeleted.length > 0">
                <div class="col-lg-auto col-12">
                  <!-- Display settings -->
                  <b-select class="form-select d-inline w-auto m-1" v-model="pageSizes.selected" @change="handleMediaDeletedDisplayChange">
                    <option v-for="size in pageSizes.options" :key="size" :value="size">{{ size }} {{ $t('pageSize') }}</option>
                  </b-select>
                  {{ countMediaDeleted }} {{ $t('resultsCount') }}
                </div>
                <!-- Pagination -->
                <div class="col-lg-auto col-12">
                  <div class="m-1 pagination-rounded">
                    <b-pagination
                        v-model="pageMediaDeleted"
                        :total-rows="countMediaDeleted"
                        :per-page="pageSizes.selected"
                        first-number
                        last-number
                        @change="handleMediaDeletedPageChange"
                        class="mb-3 justify-content-center"
                    ></b-pagination>
                  </div>
                </div>
              </div>

              <!-- result -->
              <div class="row">
                <div class="col-12">

                  <div class="masonry-deleted">
                    <div v-for="(item, key) in mediaDeleted"
                         :key="key"
                         class="media-deleted media-item">
                      <div class="media-item-content position-relative" :id="item.mediaId">
                        <img :src="item.thumb" class="media-thumb" @load="renderedDeleted(`${item.mediaId}`)" @click="mediaDeletedClick(item, key)" />
                        <div class="position-absolute top-0 w-100">
                          <div class="p-2 text-white text-center font-size-11" style="background:rgba(0, 0, 0, 0.5);" v-show="item.checked === '1'">
                            <i class="bx bx-check text-white"></i> {{ formatDate(item.checkedAt) }} - <b>{{ getInitials(item.checkedBy) }}</b>
                          </div>
                          <div class="float-end m-1">
                            <span class="text-secondary font-size-11 d-inline-block rounded-circle shadow p-1 bg-white">
                            #{{ item.rankMedia }}
                            </span>
                            <span v-if="item.isVideo" class="text-secondary ms-1 d-inline-block rounded-circle shadow p-1 bg-white">
                              <img :src="require('@/assets/images/video-play.svg')" width="20"  />
                            </span>
                          </div>
                          <div
                              class="d-inline-block text-white p-1 rounded font-size-11 m-1"
                              :class="item.sex === 1 ? 'bg-info' : 'bg-female'"
                          >{{ item.name }}
                          </div>

                        </div>
                        <div class="p-2" :class="!item.isValid ? 'bg-danger' : 'bg-white'">
                          <div class="d-flex justify-content-center mt-1">
                            <b-button class="rounded-circle ms-2 me-2 bg-white" variant="outline-success" @click="reimportMedia(item)">
                              <b-icon icon="check" scale="1.5"></b-icon>
                            </b-button>
                            <b-button class="rounded-circle ms-2 me-2 bg-white" variant="outline-secondary" @click="showUser(item.userId)">
                              <b-icon icon="search" scale="1"></b-icon>
                            </b-button>
                          </div>
                        </div>

                        <div class="p-2 bg-light text-center text-muted font-size-10">
                          #<b>{{ item.mediaId }}</b>
                        </div>
                        <div class="media-item-loading d-none"><i class="bx bx-loader-circle bx-spin"></i></div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>

              <!-- bottom list tools -->
              <div class="row mb-3" v-if="!isLoadingMediaDeleted && mediaDeleted.length > 0">
                <!-- Display settings -->
                <div class="col-lg-auto col-12">
                  <b-select class="form-select d-inline w-auto m-1" v-model="pageSizes.selected" @change="handleMediaDeletedDisplayChange">
                    <option v-for="size in pageSizes.options" :key="size" :value="size">{{ size }} {{ $t('pageSize') }}</option>
                  </b-select>
                </div>
                <!-- Pagination -->
                <div class="col-lg-auto col-12">
                  <div class="m-1 pagination-rounded">
                    <b-pagination
                        v-model="pageMediaDeleted"
                        :total-rows="countMediaDeleted"
                        :per-page="pageSizes.selected"
                        first-number
                        last-number
                        @change="handleMediaDeletedPageChange"
                        aria-controls="users-list"
                    ></b-pagination>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </b-tab>

        <!-- Media Scored Check -->
        <b-tab>
          <template #title>
            <i class="far fa-user"></i> {{ $t('menuitems.moderation.media_scored') }}
          </template>
          <div class="card">
            <div class="card-body">
              <!-- Loader -->
              <div class="row d-flex justify-content-center">
                <vue-ellipse-progress
                    v-show="isLoadingMediaScored"
                    :loading="isLoadingMediaScored"
                    :angle="-90"
                    color="#50a5f1"
                    emptyColor="#999"
                    emptyColorFill="#f8f8fb"
                    :size="100"
                    :thickness="3"
                    :emptyThickness="2"
                    lineMode="out 2"
                    animation="bounce 700 400"
                    fontColor="#666"
                    :half="false"
                    class="mt-5 mb-5"
                    fontSize="1rem">
                </vue-ellipse-progress>
              </div>

              <!-- filters -->
              <b-form inline class="row gy-2 gx-3 align-items-center" @submit.stop.prevent>

                <!-- dates -->
                <div class="col-sm-auto d-flex">
                  <b-form-select
                      id="moderationMediaScoredDatesFilter"
                      @change="handleMediaScoredDateChange"
                      v-model="filtersMediaScored.dates.selected"
                      class="form-select me-lg-1"
                      :options="filtersMediaScored.dates.options">
                  </b-form-select>
                  <date-picker
                      v-show="filtersMediaScored.dates.selected === 'custom'"
                      lang="fr"
                      :placeholder="this.$t('choose_date_interval')"
                      type="date"
                      value-type="format"
                      show-week-number
                      v-model="filtersMediaScored.dates.dateRange"
                      class="me-lg-2"
                      range append-to-body ></date-picker>

                </div>

                <!-- Admin -->
                <div class="col-sm-auto">
                  <b-form-select
                      id="moderationAdminScoredFilter"
                      v-model="filtersMediaScored.operators.selected"
                      class="form-select me-lg-1"
                  >
                    <option v-for="st in filtersMediaScored.operators.options" :key="st.value" :value="st.value">{{ st.text }}</option>
                  </b-form-select>
                </div>

                <!-- MediaType -->
                <div class="col-sm-auto">
                  <b-form-select
                      id="moderationMediaScoredTypeFilter"
                      v-model="filtersMediaScored.mediaTypes.selected"
                      class="form-select me-lg-1"
                  >
                    <option v-for="st in filtersMediaScored.mediaTypes.options" :key="st.value" :value="st.value">{{ st.text }}</option>
                  </b-form-select>
                </div>

                <!-- MediaScore -->
                <div class="col-sm-auto">
                  <b-form-select
                      id="moderationMediaScoredTypeFilter"
                      v-model="filtersMediaScored.mediaScore.selected"
                      class="form-select me-lg-1"
                  >
                    <option v-for="st in filtersMediaScored.mediaScore.options" :key="st.value" :value="st.value">{{ st.text }}</option>
                  </b-form-select>
                </div>

                <!-- Gender -->
                <div class="col-sm-auto">
                  <b-form-select
                      id="moderationMediaScoredGenderFilter"
                      v-model="filtersMediaScored.gender.selected"
                      class="form-select me-lg-1"
                  >
                    <option v-for="st in filtersMediaScored.gender.options" :key="st.value" :value="st.value">{{ st.text }}</option>
                  </b-form-select>
                </div>

                <!-- userType -->
                <div class="col-sm-auto" v-show="isSpecial">
                  <b-form-select
                      id="moderationMediaScoredSpecialFilter"
                      v-model="filtersMediaScored.userTypes.selected"
                      class="form-select me-lg-1"
                  >
                    <option v-for="st in filtersMediaScored.userTypes.options" :key="st.value" :value="st.value">{{ st.text }}</option>
                  </b-form-select>
                </div>

                <!-- toCheck -->
                <div class="col-sm-auto" v-show="isSpecial">
                  <b-form-select
                      id="moderationMediaScoredToCheckFilter"
                      v-model="filtersMediaScored.toChecked.selected"
                      class="form-select me-lg-1"
                  >
                    <option v-for="st in filtersMediaScored.toChecked.options" :key="st.value" :value="st.value">{{ st.text }}</option>
                  </b-form-select>
                </div>


                <div class="col-sm-auto">
                  <b-button variant="primary" class="w-md" @click="processFiltersMediaScored">{{ $t("find") }}</b-button>
                </div>

              </b-form>
              <hr>

              <!-- Top list tools -->
              <div class="row mb-3" v-if="!isLoadingMediaScored && mediaScored.length > 0">
                <div class="col-lg-auto col-12">
                  <!-- Display settings -->
                  <b-select class="form-select d-inline w-auto m-1" v-model="pageSizes.selected" @change="handleMediaScoredDisplayChange">
                    <option v-for="size in pageSizes.options" :key="size" :value="size">{{ size }} {{ $t('pageSize') }}</option>
                  </b-select>
                  {{ countMediaScored }} {{ $t('resultsCount') }}
                </div>
                <!-- Pagination -->
                <div class="col-lg-auto col-12">
                  <div class="m-1 pagination-rounded">
                    <b-pagination
                        v-model="pageMediaScored"
                        :total-rows="countMediaScored"
                        :per-page="pageSizes.selected"
                        first-number
                        last-number
                        @change="handleMediaScoredPageChange"
                        class="mb-3 justify-content-center"
                    ></b-pagination>
                  </div>
                </div>
              </div>

              <!-- result -->
              <div class="row">
                <div class="col-12">

                  <div class="masonry-scored">
                    <div v-for="(item, key) in mediaScored"
                         :key="key"
                         class="media-scored media-item">
                      <div class="media-item-content position-relative" :id="'scored-' + item.mediaId">
                        <img :src="item.thumb" class="media-thumb" @load="renderedScored(`${item.mediaId}`)" @click="mediaScoredClick(item, key)" />
                        <div class="position-absolute top-0 w-100">
                          <div class="p-2 text-white text-center font-size-11" style="background:rgba(0, 0, 0, 0.5);">
                            <i class="bx bx-check text-white"></i> {{ formatDate(item.mediaScoreAt) }} - <b>{{ getInitials(item.mediaScoreBy) }}</b>
                          </div>
                          <div class="float-end m-1">
                            <span class="text-secondary font-size-11 d-inline-block rounded-circle shadow p-1 bg-white">
                            #{{ item.rankMedia }}
                            </span>
                            <span v-if="item.isVideo" class="text-secondary ms-1 d-inline-block rounded-circle shadow p-1 bg-white">
                              <img :src="require('@/assets/images/video-play.svg')" width="20"  />
                            </span>
                          </div>
                          <div
                              class="d-inline-block text-white p-1 rounded font-size-11 m-1"
                              :class="item.sex === 1 ? 'bg-info' : 'bg-female'"
                          >{{ item.name }}, {{ getAge(item.birth) }}
                          </div>
                          <div v-if="isSpecial">
                            <div
                                class="d-inline-block text-white p-1 rounded font-size-11 m-1 "
                                :class="item.userType === 1 ? 'bg-success' : 'bg-warning'"
                                 v-if="item.isSpecial === 1"
                            >
                              <span v-show="item.userType === 0">S</span>
                              <span v-show="item.userType === 1">L</span>
                            </div>
                          </div>
                        </div>
                        <div class="p-2 bg-white">
                          <div class="d-flex justify-content-center mt-1" v-show="item.isValid">
                            <b-form-group
                                label="Score ranking"
                                v-slot="{ ariaDescribedby }"
                            >
                              <b-form-radio-group
                                  v-model="item.mediaScore"
                                  :options="item.isVideo ? mediaOptionsVideo : mediaOptionsImage"
                                  button-variant="outline-primary"
                                  name="radio-btn-outline"
                                  buttons
                              ></b-form-radio-group>
                            </b-form-group>
                          </div>
                          <div class="d-flex justify-content-center mt-1">
                            <b-button class="rounded-circle ms-2" variant="primary" @click="markAsVerified(item)">
                              <b-icon icon="check" scale="1"></b-icon>
                            </b-button>
                            <b-button class="rounded-circle ms-2 me-2 bg-white" variant="outline-secondary" @click="showUser(item.userId)">
                              <b-icon icon="search" scale="1"></b-icon>
                            </b-button>
                          </div>
                        </div>
                        <div class="p-2 bg-light text-center text-muted font-size-10">
                          #<b>{{ item.mediaId }}</b>
                        </div>
                        <div class="media-item-loading d-none"><i class="bx bx-loader-circle bx-spin"></i></div>
                      </div>
                    </div>
                  </div>

                  <div class="align-content-center mt-3 mb-3" v-show="isSpecial && filtersMediaScored.toChecked.selected === 0">
                    <b-button
                        v-show="loadedMediaScored && !isLoadingMediaScored && mediaScored.length > 0 "
                        @click="setScoreChecked"
                        variant="success">
                      <i class="bx bx-trending-up"></i> {{ $t("valid") }}
                    </b-button>

                    <div class="status" v-show="loadedMediaScored && isLoadingMediaScored">
                      <div class="spinner-chase">
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>

              <!-- bottom list tools -->
              <div class="row mb-3" v-if="!isLoadingMediaScored && mediaScored.length > 0">
                <!-- Display settings -->
                <div class="col-lg-auto col-12">
                  <b-select class="form-select d-inline w-auto m-1" v-model="pageSizes.selected" @change="handleMediaScoredDisplayChange">
                    <option v-for="size in pageSizes.options" :key="size" :value="size">{{ size }} {{ $t('pageSize') }}</option>
                  </b-select>
                </div>
                <!-- Pagination -->
                <div class="col-lg-auto col-12">
                  <div class="m-1 pagination-rounded">
                    <b-pagination
                        v-model="pageMediaScored"
                        :total-rows="countMediaScored"
                        :per-page="pageSizes.selected"
                        first-number
                        last-number
                        @change="handleMediaScoredPageChange"
                        aria-controls="users-list"
                    ></b-pagination>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </b-tab>

        <!-- Update Check -->
        <b-tab>
          <template #title>
            <i class="far fa-user"></i> {{ $t('menuitems.members.updates') }}
          </template>
          <div class="card">
            <div class="card-body">
              <!-- Loader -->
              <div class="row d-flex justify-content-center">
                <vue-ellipse-progress
                    v-show="isLoadingUpdates"
                    :loading="isLoadingUpdates"
                    :angle="-90"
                    color="#50a5f1"
                    emptyColor="#999"
                    emptyColorFill="#f8f8fb"
                    :size="100"
                    :thickness="3"
                    :emptyThickness="2"
                    lineMode="out 2"
                    animation="bounce 700 400"
                    fontColor="#666"
                    :half="false"
                    class="mt-5 mb-5"
                    fontSize="1rem">
                </vue-ellipse-progress>
              </div>

              <!-- filters -->
              <b-form inline class="row gy-2 gx-3 align-items-center" @submit.stop.prevent>

                <!-- dates -->
                <div class="col-sm-auto d-flex">
                  <b-form-select
                      id="moderationUpdatesDatesFilter"
                      @change="handleUpdatesDateChange"
                      v-model="filtersUpdates.dates.selected"
                      class="form-select me-lg-1"
                      :options="filtersUpdates.dates.options">
                  </b-form-select>
                  <date-picker
                      v-show="filtersUpdates.dates.selected === 'custom'"
                      lang="fr"
                      :placeholder="this.$t('choose_date_interval')"
                      type="date"
                      value-type="format"
                      show-week-number
                      v-model="filtersUpdates.dates.dateRange"
                      class="me-lg-2"
                      range append-to-body ></date-picker>

                </div>

                <!-- Admin -->
                <div class="col-sm-auto">
                  <b-form-select
                      id="actionsAdminFilter"
                      v-model="filtersUpdates.operators.selected"
                      class="form-select me-lg-1"
                  >
                    <option v-for="st in filtersUpdates.operators.options" :key="st.value" :value="st.value">{{ st.text }}</option>
                  </b-form-select>
                </div>

                <div class="col-sm-auto">
                  <b-button variant="primary" class="w-md" @click="processFiltersUpdates">{{ $t("find") }}</b-button>
                </div>
              </b-form>
              <hr>

              <!-- Top list tools -->
              <div class="row mb-3" v-if="!isLoadingUpdates && updates.length > 0 ">
                <div class="col-lg-auto col-12">
                  <!-- Display settings -->
                  <b-select class="form-select d-inline w-auto m-1" v-model="pageSizes.selected" @change="handleUpdatesDisplayChange">
                    <option v-for="size in pageSizes.options" :key="size" :value="size">{{ size }} {{ $t('pageSize') }}</option>
                  </b-select>
                  {{ countUpdates }} {{ $t('resultsCount') }}
                </div>
                <!-- Pagination -->
                <div class="col-lg-auto col-12">
                  <div class="m-1 pagination-rounded">
                    <b-pagination
                        v-model="pageUpdates"
                        :total-rows="countUpdates"
                        :per-page="pageSizes.selected"
                        first-number
                        last-number
                        @change="handleUpdatesPageChange"
                        aria-controls="updates-list"
                    ></b-pagination>
                  </div>
                </div>
              </div>

              <!-- Result list -->
              <div class="row" v-if="!isLoadingUpdates && updates.length > 0">
                <div class="table-responsive">
                  <table
                      id="updates-list"
                      class="table project-list-table table-centered table-borderless align-middle">
                    <thead class="table-light">
                    <tr>
                      <th scope="col" style="width:180px !important;">Operator</th>
                      <th scope="col" style="width:180px !important;">Date</th>
                      <th scope="col">Type</th>
                      <th scope="col">{{ $t("users.user") }}</th>
                      <th scope="col">Nouveau</th>
                      <th scope="col">Ancien</th>
                      <th scope="col">{{ $t("action") }}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="user in updates" :key="user.documentId"
                        :class="{
                        'bg-light': user.disabled === 1
                        }">
                      <td>
                        <div class="media align-items-center">
                          <div class="avatar-xs">
                            <span
                                class="avatar-title rounded-circle font-size-15 bg-light text-dark"
                            >{{ getInitials(user.checkedBy) }}</span>
                          </div>
                          <div class="media-body ms-2">
                            {{ user.checkedBy }}
                          </div>
                        </div>
                      </td>
                      <td>
                        <p class="text-muted font-size-12">
                          <i class="bx bx-calendar-event"></i> <b>{{ formatDateString(user.checkedAt, 'DD MMM YYYY HH:mm') }}</b><br>
                          <small>{{ formatDateString(user.updateCreatedAt, 'DD MMM YYYY HH:mm') }}</small>
                        </p>
                      </td>
                      <td>
                  <span
                      class="badge"
                      :class="{
                        'bg-danger text-light': `${user.reason}` === 'name',
                        'bg-info text-light': `${user.reason}` === 'description',
                      }"
                  >{{ user.reason }}</span
                  >
                      </td>
                      <td>
                        <div class="media" v-if="user.userId !== null" @click="showUser(user.userId)">
                          <div class="avatar-xs">
                            <img
                                :id="`verify-member-${user.documentId}`"
                                :src="require('@/assets/images/users/default-user.png')"
                                class="d-flex rounded-circle avatar-xs" />
                          </div>
                          <div class="media-body ms-1">
                            <h5 class="font-size-12 mb-0">
                            <span
                                :class="{
                                'text-primary': user.sex === 1,
                                'text-danger': user.sex === 2,
                                'text-dark': user.sex === 0,
                              }"
                            >
                              {{ user.name || '-' }}
                            </span> {{ getAge(user.birth) }}</h5>
                            <small class="text-muted">#{{ user.userId }}</small>
                          </div>
                        </div>
                      </td>
                      <td>
                        <small>Nouveau:</small><br />
                        {{ isEmpty(user.updatesData.new) ? "no data" : user.updatesData.new }}
                      </td>
                      <td>
                        <small>Ancien:</small><br />
                        {{ isEmpty(user.updatesData.old) ? "no data" : user.updatesData.old }}
                      </td>
                      <td>
                        <b-dropdown
                            class="card-drop"
                            variant="white"
                            menu-class="dropdown-menu-end"
                            right
                            toggle-class="p-0"
                        >
                          <template v-slot:button-content>
                            <i class="mdi mdi-dots-horizontal font-size-18"></i>
                          </template>
                          <b-dropdown-item
                              href="javascript: void(0);"
                              @click="showUser(user.userId)"
                          >{{ $t("show_user") }}</b-dropdown-item>
                        </b-dropdown>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <!-- Result Empty -->
              <div class="row" v-if="!isLoadingUpdates && updates.length === 0">
                <div class="col-12">
                  <div class="card">
                    <div class="card-body">
                      <h4 class="card-title">Empty Result</h4>
                      <p>No profiles updates found. Try later.</p>
                    </div>
                  </div>
                </div>
              </div>

              <!-- bottom list tools -->
              <div class="row mb-3" v-if="!isLoadingUpdates && updates.length > 0 ">
                <!-- Display settings -->
                <div class="col-lg-auto col-12">
                  <b-select class="form-select d-inline w-auto m-1" v-model="pageSizes.selected" @change="handleUpdatesDisplayChange">
                    <option v-for="size in pageSizes.options" :key="size" :value="size">{{ size }} {{ $t('pageSize') }}</option>
                  </b-select>
                </div>
                <!-- Pagination -->
                <div class="col-lg-auto col-12">
                  <div class="m-1 pagination-rounded">
                    <b-pagination
                        v-model="pageUpdates"
                        :total-rows="countUpdates"
                        :per-page="pageSizes.selected"
                        first-number
                        last-number
                        @change="handleUpdatesPageChange"
                        aria-controls="updates-list"
                    ></b-pagination>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </b-tab>

        <!-- Profiles Check -->
        <b-tab>
          <template #title>
            <i class="far fa-user"></i> {{ $t('menuitems.moderation.verify') }}
          </template>
          <div class="card">
            <div class="card-body">
              <!-- Loader -->
              <div class="row d-flex justify-content-center">
              <vue-ellipse-progress
                  v-show="isLoadingProfiles"
                  :loading="isLoadingProfiles"
                  :angle="-90"
                  color="#50a5f1"
                  emptyColor="#999"
                  emptyColorFill="#f8f8fb"
                  :size="100"
                  :thickness="3"
                  :emptyThickness="2"
                  lineMode="out 2"
                  animation="bounce 700 400"
                  fontColor="#666"
                  :half="false"
                  class="mt-5 mb-5"
                  fontSize="1rem">
              </vue-ellipse-progress>
            </div>

              <!-- filters -->
              <b-form inline class="row gy-2 gx-3 align-items-center" @submit.stop.prevent>

                <!-- dates -->
                <div class="col-sm-auto d-flex">
                  <b-form-select
                      id="moderationProfilesDatesFilter"
                      @change="handleProfilesDateChange"
                      v-model="filtersProfiles.dates.selected"
                      class="form-select me-lg-1"
                      :options="filtersProfiles.dates.options">
                  </b-form-select>
                  <date-picker
                      v-show="filtersProfiles.dates.selected === 'custom'"
                      lang="fr"
                      :placeholder="this.$t('choose_date_interval')"
                      type="date"
                      value-type="format"
                      show-week-number
                      v-model="filtersProfiles.dates.dateRange"
                      class="me-lg-2"
                      range append-to-body ></date-picker>

                </div>

                <!-- Admin -->
                <div class="col-sm-auto">
                  <b-form-select
                      id="actionsAdminFilter"
                      v-model="filtersProfiles.operators.selected"
                      class="form-select me-lg-1"
                  >
                    <option v-for="st in filtersProfiles.operators.options" :key="st.value" :value="st.value">{{ st.text }}</option>
                  </b-form-select>
                </div>

                <div class="col-sm-auto">
                  <b-button variant="primary" class="w-md" @click="processFiltersProfiles">{{ $t("find") }}</b-button>
                </div>
              </b-form>
              <hr>

              <!-- Top list tools -->
              <div class="row mb-3">
                <div class="col-lg-auto col-12">
                  <!-- Display settings -->
                  <b-select class="form-select d-inline w-auto m-1" v-model="pageSizes.selected" @change="handleProfileDisplayChange">
                    <option v-for="size in pageSizes.options" :key="size" :value="size">{{ size }} {{ $t('pageSize') }}</option>
                  </b-select>

                  {{ countProfiles }} {{ $t('resultsCount') }}
                </div>
                <!-- Pagination -->
                <div class="col-lg-auto col-12">
                  <div class="m-1 pagination-rounded">
                    <b-pagination
                        v-model="pageProfiles"
                        :total-rows="countProfiles"
                        :per-page="pageSizes.selected"
                        first-number
                        last-number
                        @change="handleProfilesPageChange"
                        aria-controls="profiles-list"
                    ></b-pagination>
                  </div>
                </div>
              </div>

              <!-- Result list -->
              <div class="row" v-if="!isLoadingProfiles && profiles.length > 0">
                <div class="table-responsive">
                  <table
                      id="profiles-list"
                      class="table project-list-table table-centered table-borderless align-middle">
                    <thead class="table-light">
                    <tr>
                      <th scope="col">Operator</th>
                      <th scope="col">Date</th>
                      <th scope="col" style="width:130px !important;">Media</th>
                      <th scope="col">{{ $t("users.user") }}</th>
                      <th scope="col">{{ $t("status") }}</th>
                      <th scope="col">{{ $t("gender") }} / {{ $t("age") }}</th>
                      <th scope="col">{{ $t("email") }} / ID</th>
                      <th scope="col">{{ $t("date") }}</th>
                      <th scope="col">{{ $t("ip") }}</th>
                      <th scope="col">{{ $t("action") }}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="user in profiles" :key="user.userId"
                        :class="{
                        'bg-light': user.disabled === 1
                        }"
                        @click="showUser(user.userId)"
                      >
                      <td>
                        <div class="media align-items-center">
                          <div class="avatar-xs">
                            <span
                                class="avatar-title rounded-circle font-size-15 bg-light text-dark"
                            >{{ getInitials(user.checkedBy) }}</span>
                          </div>
                          <div class="media-body ms-2">
                            {{ user.checkedBy }}
                          </div>
                        </div>
                      </td>
                      <td>
                        <p class="text-muted font-size-12">
                          <i class="bx bx-calendar-event"></i> <b>{{ formatDateString(user.checkedAt, 'DD MMM YYYY HH:mm') }}</b><br>
                        </p>
                      </td>
                      <td>
                        <a href="javascript: void(0);" @click="showMedia(user, 0)" v-show="user.photo && user.photo.length > 0" class="d-inline-block">
                          <div :id="user.userId + '-img'" class="rounded-circle avatar-sm"  />
                        </a>
                        <span class="badge rounded-pill m-n3 bg-danger" v-show="user.countMedia>0">{{ user.countMedia }}</span>
                        <a href="javascript: void(0);" @click="showMedia(user, 1)" v-show="user.video && user.video.length > 0" class="d-inline-block ms-4">
                          <div :id="user.userId + '-video'" class="rounded-circle avatar-sm" />
                        </a>
                        <span class="badge rounded-pill m-n3 bg-primary" v-show="user.video && user.video.length > 0"><b-icon icon="play-fill" aria-hidden="true" ></b-icon></span>
                      </td>
                      <td>
                        <b>{{ user.name }}</b>
                        <span
                            class="badge ms-1"
                            :class="{
                      'bg-success': `${user.status}` === 'online',
                      'bg-dark': `${user.status}` === 'off',
                    }"
                        >{{ user.status }}</span>
                        <br>
                        <country-flag :country='user.country' size='small'/> {{ user.locality }}, {{ getCountry(user) }}
                        <br><small>{{ user.ip || '-' }}</small>
                      </td>
                      <td>
                        <span class="badge bg-dark" v-show="user.disabled === 1">{{ $t("user_disabled") }}</span>
                        <span class="badge bg-warning" v-show="user.isRegistered === 0">{{ $t("incomplete") }}</span>
                        <span class="badge bg-info" v-show="user.isRegistered === 1 && user.disabled === 0">{{ $t("complete") }}</span>
                      </td>
                      <td>
                        <img :src="getGenderImg(user.sex)" alt=""> /
                        <span class="lead">{{ getAge(user.birth) }}</span> /
                        <img :src="getGenderSearchImg(user.search)" alt="">
                      </td>
                      <td> {{ user.email }} <br>
                        <small>{{ user.userId }}</small><br>
                        <small>{{ user.phone }}</small><br>
                      </td>
                      <td>
                        <i class="bx bx-calendar-event"></i> <b>{{ new Date(user.createdAt) | moment('DD MMM YYYY HH:mm') }}</b><br>
                        <i class="mdi mdi-connection"></i> {{ new Date(user.loggedAt) | moment('DD MMM YYYY HH:mm') }}
                      </td>
                      <td>
                        <i class="fas fa-network-wired"></i> {{ user.registerIp || '-' }}
                      </td>
                      <td>
                        <b-dropdown
                            class="card-drop"
                            variant="white"
                            menu-class="dropdown-menu-end"
                            right
                            toggle-class="p-0"
                        >
                          <template v-slot:button-content>
                            <i class="mdi mdi-dots-horizontal font-size-18"></i>
                          </template>
                          <b-dropdown-item
                              href="javascript: void(0);"
                              @click="showUser(user.userId)"
                          >{{ $t("show_user") }}</b-dropdown-item>
                        </b-dropdown>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <!-- Result Empty -->
              <div class="row" v-if="!isLoadingProfiles && profiles.length === 0">
                <div class="col-12">
                  <div class="card">
                    <div class="card-body">
                      <h4 class="card-title">Empty Result</h4>
                      <p>No Users were found for these filters. Try again.</p>
                    </div>
                  </div>
                </div>
              </div>

              <!-- bottom list tools -->
              <div class="row mb-3">
                <!-- Display settings -->
                <div class="col-lg-auto col-12">
                  <b-select class="form-select d-inline w-auto m-1" v-model="pageSizes.selected" @change="handleProfileDisplayChange">
                    <option v-for="size in pageSizes.options" :key="size" :value="size">{{ size }} {{ $t('pageSize') }}</option>
                  </b-select>
                </div>
                <!-- Pagination -->
                <div class="col-lg-auto col-12">
                  <div class="m-1 pagination-rounded">
                    <b-pagination
                        v-model="pageProfiles"
                        :total-rows="countProfiles"
                        :per-page="pageSizes.selected"
                        first-number
                        last-number
                        @change="handleProfilesPageChange"
                        aria-controls="profiles-list"
                    ></b-pagination>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </b-tab>

      </b-tabs>

    </div>

    <b-sidebar id="sidebar-right" right v-model="isUserPaneDisplayed">
      <vue-tabs
          v-model="userTabsActive"
          active-tab-color="#213213"
          active-text-color="white">
        <v-tab v-for="userTab in userTabs" :key="userTab.userId" :title="userTab.userId" >
          <div slot="title">{{ userTab.name }} <i @click.stop="removeUserTab(userTab.userId)" class="bx bx-x-circle" ></i></div>
          <UserProfile
              :userId="null"
              :user="userTab"
              v-on:SHOW_MEDIA="showUserMedia">
          </UserProfile>
        </v-tab>
      </vue-tabs>
    </b-sidebar>

    <!-- lightshow results -->
    <CoolLightBox
        :items="media"
        :index="indexMedia"
        :effect="'fade'"
        @close="indexMedia = null">
    </CoolLightBox>

    <CoolLightBox
        :items="mediaDeleted"
        :index="indexMediaDeleted"
        :effect="'fade'"
        @close="indexMediaDeleted = null">
    </CoolLightBox>

    <CoolLightBox
        :items="mediaScored"
        :index="indexMediaScored"
        :effect="'fade'"
        @close="indexMediaScored = null">
    </CoolLightBox>

    <CoolLightBox
        :items="userMedia.media"
        :index="userMedia.index"
        :effect="'fade'"
        @close="userMedia.index = null">
    </CoolLightBox>

  </Layout>
</template>

<style>
.cursor-pointer {
  cursor:pointer;
}

.masonry, .masonry-deleted, .masonry-scored {
  display: grid;
  grid-gap: 15px;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  /*grid-auto-rows: 0;*/
  /*min-height: 450px !important;*/
}

.bg-female {
  background-color: #f06292;
}

.mediaImg {
  max-height: calc(100vh - 100px);
  border-radius: 10px;
  border-top-right-radius-radius:0px;
  border-bottom-right-radius-radius:0px;
}

.media-item {
  min-height: 200px !important;
}

.media-item input[type="radio"] {
  visibility: hidden;
}

.media-item input[type="radio"]+span {
  margin-left:-10px;
}

.media-item-content {
  overflow: hidden;
  border-radius: 5px;
  width: 100%;
  background: #F5F5F5;
  box-shadow: 0 0 10px #999;
}

.media-item-loading {
  position: absolute;
  top:0;
  right:0;
  bottom: 0;
  left:0;
  text-align: center;
  background-color: rgba(255, 255, 255, .7);
}

.media-item-loading i {
  font-size: 60px;
  margin-top: 100px;
}

.media-item-content img.media-thumb {
  object-fit: cover;
  width: 100%;
  height: 100%;
  line-height: 0;
  display: block;
}

.avatar-sm {
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
}

.gender-img {
  max-width: 30px;
  margin-right: 10px;
}

.b-sidebar-right {
  width:35%;
}

.b-sidebar-body {
  padding:16px;
}

</style>
